// Minimal blank landing page for document hosting domain
const BlankLanding = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl text-gray-400 font-light">tmrsrc.com</h1>
      </div>
    </div>
  );
};

export default BlankLanding;



